import PropTypes from "prop-types";
import React, { createContext, useReducer } from "react";
import { pdfContextActionTypes, pdfReducer } from "./pdf-reducer";

const initialState = {
    pdfFileName: '',
    pdfKey: 0,
    isPreviewButtonClicked: false,
    isDownloadButtonClicked: false,
    isShareButtonClicked: false,
};

export const PdfContext = createContext( { state: initialState } );

export default function PdfContextProvider( { children } ) {
    const [ state, dispatch ] = useReducer( pdfReducer, initialState );

    const setPdfFileName = ( value ) => {
        dispatch( {
            type: pdfContextActionTypes.SET_PDF_FILE_NAME,
            payload: value,
        } );
    }

    const initiatePreviewTab = () => {
        dispatch( {
            type: pdfContextActionTypes.INITIATE_PREVIEW,
        } );
    }

    const finalizePreviewTab = () => {
        dispatch( {
            type: pdfContextActionTypes.FINALISE_PREVIEW,
        } );
    }

    const initiateDownloadModal = () => {
        dispatch( {
            type: pdfContextActionTypes.INITIATE_DOWNLOAD,
        } );
    }

    const finalizeDownloadModal = () => {
        dispatch( {
            type: pdfContextActionTypes.FINALISE_DOWNLOAD,
        } );
    }

    const initiateShareModal = () => {
        dispatch( {
            type: pdfContextActionTypes.INITIATE_SHARE,
        } );
    }

    const finalizeShareModal = ( value ) => {
        dispatch( {
            type: pdfContextActionTypes.FINALISE_SHARE,
            payload: value,
        } );
    }

    const contextValue = {
        state,
        dispatch,
        setPdfFileName,
        initiatePreviewTab,
        finalizePreviewTab,
        initiateDownloadModal,
        finalizeDownloadModal,
        initiateShareModal,
        finalizeShareModal,
    };

    return <PdfContext.Provider value={ contextValue }>
        { children }
    </PdfContext.Provider>
}

PdfContext.propTypes = {
    children: PropTypes.node.isRequired,
}
